import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

function getSchema() {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .object({
      displayDutyCode: yup
        .string()
        .required(t('validationFieldRequired', { name: t('dutyCode') })),
      colorCode: yup.string()
    })
    .required();
}

export default getSchema;
